// extracted by mini-css-extract-plugin
export default {"navbar":"Home_navbar__fH0kV","navDiv":"Home_navDiv__50Bmf","divbox":"Home_divbox__AFsz4"};